<template>
  <div class="Slider">
    <Loader v-if="isLoading" />
    <swiper v-else :options="swiperOption">
      <!-- slides -->
      <swiper-slide class="Slider__item" v-for="slider in sliders" :key="slider.id">
        <router-link :to="'/'+slider.redirect_url">
          <img :src="img(slider.imageUrl)" alt />
        </router-link>
      </swiper-slide>
      <!-- Optional controls -->
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>
// eslint-disable-next-line
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  data() {
    return {
      sliders: [],
      isLoading: true,
      swiperOption: {
        loop: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true
        }
      }
    }
  },
  components: {
    swiper,
    swiperSlide
  },
  created() {
    this.$http.get('contents/slider').then((res) => {
      this.sliders = res.data.data
      if (this.sliders.length === 1) {
        this.swiperOption.autoplay = false
      }
      this.isLoading = false
    })
  }
}
</script>

<style lang="scss" scoped>
.swiper-button-prev {
  margin-left: 10rem;
  background-image: url("../assets/img/left-arrow.svg");
}
.swiper-button-next {
  margin-right: 10rem;
  background-image: url("../assets/img/right-arrow.svg");
}
</style>
